import { render, staticRenderFns } from "./PresentationToExpireTable.vue?vue&type=template&id=a4179614&"
import script from "./PresentationToExpireTable.vue?vue&type=script&lang=js&"
export * from "./PresentationToExpireTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports